import {put, select, takeLatest} from 'redux-saga/effects';
import {getAnalyticsV3Api} from 'helpers/services/api/analytics';
import {
  normalizeSalesCount,
  unwrapAnalyticsPayload
} from 'helpers/services/api/analyticsHelpers';
import {GET_SALES_COUNT, GET_SALES_COUNT_SUCCESS} from './action';

function* getSalesCount({payload}) {
  try {
    const timestamp = new Date().getTime();
    const {locationId} = yield select((state) => state.user);
    const response = yield getAnalyticsV3Api(locationId, {
      startDate: payload.startDate,
      endDate: payload.endDate,
      channelTypes: payload.channelTypes,
      fulfillmentModes: payload.fulfillmentModes,
      includeSalesPerItem: false,
      includeKpi: true,
      includePerHoursStatistics: false,
      includeSalesCountSeries: true
    });
    const data = normalizeSalesCount(unwrapAnalyticsPayload(response));
    yield put(
      GET_SALES_COUNT_SUCCESS({
        data: data && Object.keys(data).length ? data : {},
        timestamp
      })
    );
  } catch (error) {
    const timestamp = new Date().getTime();
    yield put(GET_SALES_COUNT_SUCCESS({data: {}, timestamp}));
    console.log('SAGA ERROR', error);
  }
}

function* analyticsSalesCountSaga() {
  yield takeLatest(GET_SALES_COUNT, getSalesCount);
}

export default analyticsSalesCountSaga;
